import { render, staticRenderFns } from "./userStream.vue?vue&type=template&id=45fb3ce4&scoped=true"
import script from "./userStream.vue?vue&type=script&lang=js"
export * from "./userStream.vue?vue&type=script&lang=js"
import style0 from "./userStream.vue?vue&type=style&index=0&id=45fb3ce4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb3ce4",
  null
  
)

export default component.exports